import Prism from 'prismjs/prism.js';
Prism.plugins.autoloader.languages_path = craft.env.assetsSiteUrl + '/assets/js/common/prismjs/components/';
import PrismAutoloader from 'prismjs/plugins/autoloader/prism-autoloader.min.js';
import Api from "../../../lib/api";
import HeroSection from "../../components/hero-section";
import PhotoGallery from "../../../components/base/photo-gallery";
import YoutubeVideo from "../../../components/base/youtube-video";
import { PostStatistics } from "../../components/user-activity";

export default class PageModule {
	constructor() {
		this.initPostStatisticsModule();
		this.initHeroSection();
		this.initHeroYoutubeVideo();
		this.initYoutubeVideoSections();
		this.initPhotoGallery();
		this.handleRecommendedCourseLinks();
	}

	initPostStatisticsModule() {
		const postStatistics = new PostStatistics();
	}

	initHeroSection() {
		const heroSection = new HeroSection();
	}

	initHeroYoutubeVideo() {
		const $heroPostVideo = document.getElementById('heroPostVideo');
		const $heroPostVideoTimeline = document.querySelector(`[data-for="${$heroPostVideo.id}"]`);
		const youtubeVideo = new YoutubeVideo($heroPostVideo, $heroPostVideoTimeline);
	}

	initYoutubeVideoSections() {
		const $videoSections = document.querySelectorAll('.post-constructor-youtube');

		if ($videoSections.length) {
			$videoSections.forEach(($videoSection) => {
				if ($videoSection.id !== 'heroPostVideo') {
					const youtubeVideo = new YoutubeVideo($videoSection);
				}
			});
		}
	}

	initPhotoGallery() {
		const photoGallery = new PhotoGallery();
	}

	/* Switch href of course link to the current city link */
	handleRecommendedCourseLinks() {
		const $courseLinks = document.querySelectorAll('.recommended-course-link');

		if (!$courseLinks.length) {
			return;
		}

		$courseLinks.forEach(($courseLink) => {
			const cityId = Api.currentCityId;

			if ($courseLink.dataset && $courseLink.dataset[cityId]) {
				$courseLink.href = $courseLink.dataset[cityId];
			}

			if (cityId === 'online') {
				$courseLink.classList.add('-online');
			}
		});
	}
}